import { api } from '../api'

export const transferOwnership = async ({
  tableId,
  playerId
}: {
  tableId: string
  playerId: string
}): Promise<{ code: number }> =>
  await api().url(`/api/table/${tableId}/transfer-ownership`).put({ tableId, playerId }).json()
